import { Text } from '@morressier/ts';
import styled from 'styled-components';
import SciMeetingsLogo from './assets/SciMeetingsLight.svg';

import FaqItem from './Item';

import content from './content';

const Container = styled.div`
  max-width: 62.5rem;
  margin: 2rem auto;
`;

const Title = styled(Text).attrs(props => ({ size: 'h3_new', fontWeight: 'semiBold', ...props }))`
  margin: 5rem 0 1.875rem;
`;

const FaqPage = () => (
  <Container>
    <SciMeetingsLogo />
    <Title>FAQ</Title>
    {content.map(item => (
      <FaqItem {...item} key={item.key} />
    ))}
  </Container>
);

export default FaqPage;
